app.component("graftHistory", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/graftHistory/graftHistory.html",
	controller: "graftHistoryController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("graftHistoryController", [
	"$scope",
	function ($scope) {
		$scope.options = [
			{ name: "Primary non-function", model: "is_primary_non_function" },
			{ name: "Detachment", model: "is_detachment" },
			{ name: "Rejection", model: "is_rejection" },
			{ name: "Endothelial failure", model: "is_endothelial_failure" },
			{ name: "Other (specify)", model: "other" },
		];

		this.$onInit = function () {

		};

		 $scope.isRequired = () => {
				if (
					$scope.$ctrl.data.graft_history.previous_graft_failure_reason &&
					!$scope.$ctrl.data.graft_history.previous_graft_failure_reason.other
				) {
					$scope.$ctrl.data.graft_history.previous_graft_failure_reason.other_text = undefined;
				}
				return (
					!$scope.$ctrl.data.graft_history.previous_graft_failure_reason.is_primary_non_function &&
					!$scope.$ctrl.data.graft_history.previous_graft_failure_reason.is_detachment &&
					!$scope.$ctrl.data.graft_history.previous_graft_failure_reason.is_rejection &&
					!$scope.$ctrl.data.graft_history.previous_graft_failure_reason.is_endothelial_failure &&
					!$scope.$ctrl.data.graft_history.previous_graft_failure_reason.other
				);
			};
	},
]);